import { Component, Input, OnInit } from '@angular/core';
import { InstructorCentricClassItem, InstructorCentricSummary } from '../../../models/instructor-centric-report-model';

@Component({
    selector: 'app-instructor-centric-report-item',
    templateUrl: './instructor-centric-report-item.component.html',
    styleUrls: ['./instructor-centric-report-item.component.scss'],
    standalone: false
})
export class InstructorCentricReportItemComponent implements OnInit {
    @Input()
    summaryItem: InstructorCentricSummary;
    constructor() {}

    ngOnInit() {}

    public attendanceProvided(item: InstructorCentricClassItem): boolean {
        return item.classAttendance !== null;
    }
}
